import {classNames, Fragment, observer, React, useAsObservableSource, utils} from '@api'
import {Icon, Menu, MenuDivider, MenuItem, Spinner} from '@blueprintjs/core'
import {Popover2} from '@api'
import {TabNode, useTabButtonStore} from '@flexlayout'
import {Card} from '@material-ui/core'
import {CatalogTabMenuItems, ContextMenuItem, ContextMenuItemProps, CurrentWorkspaceSyncToolbarButton, IFlexLayoutWhiteboardTabConfig, SaveCurrentCatalogAsPresetMenuItem, StoresInstanceContext, SwitchCurrentCatalogPresetMenuItem, SwitchFlexCatalogRootViewModeMenuItems, useStores, WorkspaceChooserMenuItems} from '@modules'
import {DevCatalogContextMenuItems} from '@modules/contextMenus/menus/DevCatalogContextMenuItems'
import {globalStores, CatalogRootFlexLayoutStoreContext, icons} from '@stores'
import {IFlexLayoutCatalogRootConfig, useCatalogRootFlexLayoutStore} from '@stores/catalog/flexLayout'
import * as css from './FlexLayoutCustomTab.css'
import {PrimaryIconButton} from 'centric-ui-components'
import {CatalogItemDetailsTabContent} from './CatalogItemDetailsTabContent'

export const FlexCatalogTabTitleCount = observer<{ tab: TabNode, className?: string }>(function FlexCatalogTabTitleCount({tab, className}) {
  if (!tab) return null

  const count = tab.itemCount ?? tab.storesToInject?.catalog?.itemCount

  if (!_.isNumber(tab.itemCount) && (tab.component !== 'catalog' || !_.isNumber(count))) return null

  const displayValue = count.toLocaleString()

  return (
    <div title={displayValue} className={classNames(css.titleCount, className)}>
      ({displayValue})
    </div>
  )
})

export const FlexLayoutTabSpinnerIcon = observer(function FlexLayoutTabSpinnerIcon() {
  return <Spinner size={20}/>
})
export const MyFlexLayoutTabContentLeading = observer<{ node: TabNode }>(function MyFlexLayoutTabContentLeading({node}) {
  const {flexLayout, flexLayout: {defaultPopoverMenuProps, knownTabs, customTabMenuOpening, customTabMenuClosing}} = globalStores,
    componentName = node.component

  if (node.component === 'inlineCatalogItemDetails') return null

  const {catalogRoot} = node
  if (!node || _.isEmpty(catalogRoot) || knownTabs[node.id]) {
    const icon = flexLayout.iconFor(node)

    return <div className={css.tabLeading}>
      {_.isString(icon) ? <Icon icon={icon as any}/> : icon}
    </div>
  } else {
    const {icon} = catalogRoot


    if (icon && componentName === 'catalog') {
      //return <FlexLayoutCatalogTabViewModeDropdownToolbarMenu node={node} />
      return <CatalogRootFlexLayoutStoreContext.Provider value={catalogRoot}>
        <div data-type='TabContentLeading' className={css.tabLeadingButtons}>
          {false && <FlexLayoutCatalogTabWorkspaceChooserDropdownToolbarMenu node={node}/>}
          <FlexLayoutCatalogTabViewModeDropdownToolbarMenu node={node}/>
        </div>
      </CatalogRootFlexLayoutStoreContext.Provider>
    }

    // console.log({icon, componentName, tabStore})
    return (
      icon &&
	  <CatalogRootFlexLayoutStoreContext.Provider value={catalogRoot}>
		  <Popover2
            {...defaultPopoverMenuProps}
			className={css.tabLeading}
			onOpening={() => customTabMenuOpening()}
			onClosing={customTabMenuClosing}
			onClose={flexLayout.clearPreviewLayoutInteractionNode}
			content={<FlexLayoutCatalogTabDropdownMenu tab={node}/>}>
			  <Icon icon={icon}/>
		  </Popover2>
	  </CatalogRootFlexLayoutStoreContext.Provider>
    )
  }
})

export const MyFlexLayoutTabContent = observer<{ node: TabNode }>(function MyFlexLayoutTabContent({node}) {
  const //obsProps = useAsObservableSource({flexNode: node}),
    {flexLayout, flexLayout: {layout, maximizingTabId, defaultPopoverMenuProps, defaultCatalogNameFor, knownTabs}} = useStores(),
    config = node?.config as IFlexLayoutCatalogRootConfig,
    //catalogRoot = catalogRootFor(obsProps), // Do this to force a store to be created to initialize the menus and such without needing to have had the tab be focused once
    name = config?.nonDefaultName ? node.name : defaultCatalogNameFor(node)

  //{catalogRoot && !catalogRoot.stores.isCurrentWorkspace ? ` (${catalogRoot.catalog.title})` : ''}
  return (
    <StoresInstanceContext.Provider value={node?.storesToInject ?? globalStores}>
    <div data-type='MyFlexLayoutTabContent' className={classNames(css.tabContent, node.className)}>
      {node?.component === 'inlineCatalogItemDetails'
       ? <CatalogItemDetailsTabContent node={node}/>
       :
        // <Popover2
        //   {...defaultPopoverMenuProps}
        //   className={css.tabLeading}
        //   onClose={flexLayout.clearPreviewLayoutInteractionNode}
        //   disabled={node?.component != 'catalog' || !node.isSelected}
        //   content={<FlexLayoutCatalogTabWorkspaceDropdownMenu tab={node}/>}
        // >
       <div className={css.tabLeading}>
         <div className={css.tabTitle}
           //      onMouseEnter={e => flexLayout.tabMenuNode = node.id} onClick={(e) => {
           //   if (DEBUG) {
           //     e.metaKey && navigator.clipboard.writeText(`stores['${catalogRoot.stores.storeId}']`)
           //   }
           // }}
         >
           <span className={css.name}>{name}</span>
           <FlexCatalogTabTitleCount tab={node} className={css.titleCount}/>
           {maximizingTabId && maximizingTabId === node?.id && <Spinner className={css.maximizingSpinner}/>}
         </div>
       </div>}

      {node.tabSet && !knownTabs[node.id] &&
       <Fragment>
         {node.isSelected && !node.isInBorder && <MaximizeTabIconButton/>}
	       <div
		       className={css.caretWrapper}
             // Stop double click from triggering when clicking on the caret
		       onClick={utils.eatMouseEvent}
		       onMouseDown={utils.eatMouseEvent}
		       onMouseUp={utils.eatMouseEvent}
	       >
		       <Popover2
                 {...defaultPopoverMenuProps}
		         position='bottom'
		         modifiers={{
                   offset: {
                     enabled: true,
                     options: {
                       offset: [-5, 2]
                     }
                   },
                   flip: {
                     enabled: true
                   },
                   preventOverflow: {
                     enabled: true
                   }
                 }}
		         disabled={node.isPreviewLayout || !node.tabSet || flexLayout.knownTabs[node.id] != null || layout?.store?.editingTab === node} // || node.isGroupLabel
		         className={css.tabCaretLoaderIcon}
		         content={<Menu className={css.tabMenu}>
                   <CatalogTabMenuItems/>
                 </Menu>}
		       >
			       <Icon icon={node.isLoading ? <FlexLayoutTabSpinnerIcon/> : 'caret-down'}
                     //tooltip='Layout Actions'

                     // If you want hover behavior
                     // onMouseEnter={e => showTabMenuNodeDelayed(node.id)}
			       />
		       </Popover2>
	       </div>
       </Fragment>}
    </div>
    </StoresInstanceContext.Provider>
  )
})

export const MaximizeTabIconButton = observer(function MaximizeTabTabHeaderIcon() {
  const stores = useStores(),
    {tab} = stores

  if (!tab) return null

  return (
    <PrimaryIconButton
      tooltip='Maximize Tab'
      tooltipStyle='mui'
      className={css.maximize}
      icon='maximize'
      onClick={tab.maximize}
    />)
})

export const SyncWorkspaceMenuItem = observer<ContextMenuItemProps>(function SyncWorkspaceMenuItem(props) {
  const store = useCatalogRootFlexLayoutStore()

  if (!store) return null

  return (
    <ContextMenuItem
      text={<SyncWorkspaceTabMenuButton/>}
      onClick={e => {
        e.stopPropagation()
      }}
      {...props}
    />)
})

export const SyncWorkspaceTabMenuButton = observer(function SyncWorkspaceTabMenuButton() {
  const store = useCatalogRootFlexLayoutStore()

  if (!store) return null

  const {stores} = store
  return (<Fragment>
    <StoresInstanceContext.Provider value={stores}>
      <div className={css.syncWorkspace}>
        <CurrentWorkspaceSyncToolbarButton location='menu' key='sync' onMouseDown={(e) => utils.eatMouseEvent(e)}/>
      </div>
    </StoresInstanceContext.Provider>
  </Fragment>)
})

const FlexLayoutCatalogTabWorkspaceChooserDropdownToolbarMenu = observer<{ node: TabNode }>(function FlexLayoutCatalogTabWorkspaceChooserDropdownToolbarMenu({node}) {
  const {flexLayout, flexLayout: {defaultPopoverMenuProps, customTabMenuOpening, customTabMenuClosing}} = globalStores,
    catalogTabStore = useCatalogRootFlexLayoutStore()

  // console.log(catalogTabStore)

  return (
    <Popover2
      {...defaultPopoverMenuProps}
      className={css.tabLeading}
      onOpening={() => customTabMenuOpening()}
      onClosing={customTabMenuClosing}
      onClose={flexLayout.clearPreviewLayoutInteractionNode}
      content={<FlexLayoutCatalogTabWorkspaceDropdownMenu tab={node}/>}
    >
        <span className={css.workspaceIcon}>
          {_.first(catalogTabStore.stores.workspace?.config?.title ?? 'U')}
        </span>
    </Popover2>
  )
})

export const FlexLayoutCatalogTabViewModeDropdownToolbarMenu = observer<{ node: TabNode }>(function FlexLayoutCatalogTabViewModeDropdownToolbarMenu({node}) {
  const {flexLayout, flexLayout: {defaultPopoverMenuProps, customTabMenuOpening, customTabMenuClosing}} = globalStores,
    componentName = node.component,
    {catalogRoot} = node

  if (!node || _.isEmpty(catalogRoot)) { return null }
  const {icon} = catalogRoot

  if (componentName === 'catalog') {
    return (
      <CatalogRootFlexLayoutStoreContext.Provider value={catalogRoot}>
        <Popover2
          {...defaultPopoverMenuProps}
          className={css.tabLeading}
          disabled
          onOpening={() => customTabMenuOpening()}
          onClosing={customTabMenuClosing}
          onClose={flexLayout.clearPreviewLayoutInteractionNode}
          content={<FlexLayoutCatalogTabDropdownMenu tab={node}/>}>
          <Icon icon={icon ?? 'unknown-vehicle'}/>
        </Popover2>
      </CatalogRootFlexLayoutStoreContext.Provider>)
  }

  return null
})
export const FlexLayoutCatalogTabWorkspaceDropdownMenu = observer<{ tab: TabNode }>(function FlexLayoutCatalogTabWorkspaceDropdownMenu({tab}) {
  const {onSwitchTabWorkspace, stores} = useCatalogRootFlexLayoutStore(),
    {currentUser, workspace, presets: {selectedPreset: preset, deletePreset}} = stores

  return (<Fragment>
    <StoresInstanceContext.Provider value={stores}>
      <Menu className={css.workspaceTabDropdownMenu}>
        <WorkspaceChooserMenuItems onClickWorkspaceItem={onSwitchTabWorkspace}/>
        <MenuDivider/>
        <SaveCurrentCatalogAsPresetMenuItem/>
        <SwitchCurrentCatalogPresetMenuItem/>

        {preset && preset.creator === currentUser.info.id && <ContextMenuItem dividerBefore text='Delete Preset' icon='trash' onClick={() => deletePreset(preset)} shouldDismissPopover={false}/>}
      </Menu>
    </StoresInstanceContext.Provider>
  </Fragment>)
})

export const FlexLayoutCatalogTabDropdownMenu = observer<{ tab: TabNode }>(function FlexLayoutCatalogTabDropdownMenu({tab}) {
  const store = useCatalogRootFlexLayoutStore(),
    {vlp} = store

  return (<Fragment>
    <Menu>
      <ComponentSpecificTabMenuItems tab={tab}/>

      <SwitchFlexCatalogRootViewModeMenuItems catalogRootTab={store}/>

      {/* {vlp?.isVLPView &&
	   <Fragment>
		   <MenuDivider title='Seasonal'/>
		   <MenuItem disabled={vlp.isRefreshingSeasons} onClick={vlp.onClickRefreshSeason} text='Refresh Seasons' icon='refresh'/>
	   </Fragment>} */}

      <DevCatalogContextMenuItems/>
      {/*      <MenuDivider/>
      <SwitchFlexTabWorkspacesMenuItem showCurrentWorkspace/>
      <MenuDivider/>
      <CatalogTabMenuItems/>*/}
    </Menu>
  </Fragment>)
})

export const FilterCatalogTabDropdownToolbarMenu = observer(function FilterCatalogTabDropdownToolbarMenu() {
  const {props: {node}} = useTabButtonStore(),
    store = node.catalogRoot

  if (!store) return null

  const {strings, filter: {hasFilterTerms}, flexLayout: {showFilterTab, customTabMenuClosing, customTabMenuOpening, defaultPopoverMenuProps}} = store

  return (
    <Popover2
      {...defaultPopoverMenuProps}
      position='bottom'
      className={classNames(css.filterButton, !hasFilterTerms && css.hidden)}
      onOpening={() => customTabMenuOpening()}
      onClosing={customTabMenuClosing}
      disabled
      content={<Card className={css.filterCard} data-popover={true} raised>
        <StoresInstanceContext.Provider value={store.stores}>
          {/*<CatalogFilters className={css.filters}/>*/}
          <span>Tooltip describing the current filter state and allow users to remove filters.<br/>Leave showing the entire filter set to the sidebar.</span>
        </StoresInstanceContext.Provider>
      </Card>}>
      <PrimaryIconButton onClick={showFilterTab} icon={icons.filter} tooltip={strings.filter} tooltipPosition='bottom'/>
    </Popover2>)
})

export const MyFlexLayoutTabPinButton = observer<{ node: TabNode }>(function MyFlexLayoutTabPinButton() {
  return (<Icon className={css.pinButton} icon='pin' key='pin'/>)
})

/**
 * Custom popover for an entire panel like catalog details
 */
export const MaybePopoverWrappedFlexTabButton = observer<{ node: TabNode }>(function MaybePopoverWrappedFlexTabButton({node, children}) {
  const component = node.component

  // if (component === 'catalogItemDetails') {
  //   return (
  //     <Popover2
  //       placement='left-start'
  //       interactionKind='hover'
  //       disabled
  //       content={<CatalogItemDetailsFlexTabInfoPanel/>}
  //       minimal
  //     >
  //       {children}
  //     </Popover2>)
  // }

  return children as any
})

/*
<MyFlexTabCloseButton key="close" className={cm(CLASSES.FLEXLAYOUT__TAB_BUTTON_TRAILING)} onMouseDown={onCloseMouseDown} onClick={onClose} onTouchStart={onCloseMouseDown}/>
 */
export const MyFlexTabCloseButton = observer<{ className: string, onMouseDown, onClick, onTouchStart }>(function MyFlexTabCloseButton({className, ...props}) {
  const {node: {isEditing, isToolboxTab}, flexLayout: {model: {nonToolboxTabs}}} = useTabButtonStore()
  return /*(nonToolboxTabs.length <= 1 && !isToolboxTab) ? null : */ (!isEditing && <div className={classNames(css.tabClose, className)} {...props}>
	  <PrimaryIconButton icon='cross'/>
  </div>)
})

export const ComponentSpecificTabMenuItems = observer<{ tab: TabNode }>(function ComponentSpecificTabMenuItems({tab}) {
  const {} = useStores()

  switch (tab.component) {
    case 'whiteboard':
      const config = tab.config as IFlexLayoutWhiteboardTabConfig,
        {} = config
      return null

    default:
      return null
  }
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/flexLayout-widgets/FlexLayoutCustomTab.tsx